import { render, staticRenderFns } from "./listTokens.vue?vue&type=template&id=a6a358ce"
import script from "./listTokens.vue?vue&type=script&lang=js"
export * from "./listTokens.vue?vue&type=script&lang=js"
import style0 from "./listTokens.vue?vue&type=style&index=0&id=a6a358ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports